/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
// import {usePermissions} from '../../../../../../hook/permissions'
import {AnimaBaixo, AnimaCima2} from '../../../../../../_metronic/assets/animation/styles'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {CardLoading} from '../../../../../../_metronic/partials/widgets/loading/CardLoading'
import {Contracts, ContractsInitValues} from '../../components/contracts-list/core/_models'
import {Vertical} from '../editContracts//editOneContract/Vertical'
import {DashboardOneContract} from './/dashboardOneContract/dashboardOneContract'
import {ContractPaymentListWrapper} from '..//editContracts//contractPayment//components//contractPayment-list///ContractPaymentList'
import {RelatedFilesWrapper} from './relatedFiles/components/relatedFiles-list/relatedFilesList'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const EditContracts: FC = () => {
  // const {show} = usePermissions('Licenças')
  const intl = useIntl()
  const {uuid} = useParams()
  const [licenses, setLicenses] = useState<Contracts>(ContractsInitValues)

  useEffect(() => {
    if (uuid) {
      getlicense(uuid)
    }
  }, [uuid])

  async function getlicense(uuid: string) {
    const {data} = await axios.get(API_URL + '/sgt/v1/contracts/' + uuid)
    const license: Contracts = data.data
    setLicenses(license)
    return data
  }

  return (
    <>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'CONTRACTS.TITLE_SINGLE'}) +
          ' ' +
          (licenses.identifier === undefined ? '' : licenses.identifier)}
      </PageTitle>
      {/* Component Header de navbar. */}

      <div
        className='card d-flex g-1 py-3 px-6 mb-3'
        style={{
          flexDirection: 'row',
          width: '100%',
          alignItems: 'flex-start',
        }}
      >
        <div
          className='card d-flex justify-content-start'
          style={{
            flexDirection: 'row',
            width: '95%',
          }}
        >
          <ul className='nav'>
            <li className='nav-item  me-1'>
              <a
                className='btn btn-text-gray-600 btn-active-light-primary fs-7 active'
                data-bs-toggle='tab'
                href='#kt_tab_pane_1'
              >
                {intl.formatMessage({id: 'MENU.DASHBOARD'})}
              </a>
            </li>
            <li className='nav-item me-3'>
              <a
                className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                data-bs-toggle='tab'
                href='#kt_tab_pane_2'
              >
                {intl.formatMessage({id: 'CONTRACTS.DOCUMENT_DATA'})}
              </a>
            </li>

            <li className='nav-item me-3'>
              <a
                className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                data-bs-toggle='tab'
                href='#kt_tab_pane_3'
              >
                {intl.formatMessage({id: 'LICENSES.DOCUMENT_RELATED'})}
              </a>
            </li>

            {/* {licenses.control_ContractPayments === true && ( */}
            <li className='nav-item me-3'>
              <a
                className='btn btn-text-gray-600 btn-active-light-primary fs-7 '
                data-bs-toggle='tab'
                href='#kt_tab_pane_4'
              >
                {intl.formatMessage({id: 'CONTRACTS.EXPIRATION_PAYMENT'})}
              </a>
            </li>
          </ul>
        </div>
        <div
          className='card d-flex justify-content-end'
          style={{
            flexDirection: 'row',
            width: '5%',
          }}
        >
          <a
            type='button'
            data-bs-toggle='tab'
            href='#kt_tab_pane_9'
            className='btn btn-sm btn-icon btn-light-danger p-1'
            title='Excluir Contrato'
          >
            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-5' />
          </a>
        </div>
      </div>

      {/* Conteudo da navbar de dashboard */}
      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show ' id='kt_tab_pane_1' role='tabpanel'>
          <div className='py-0'>
            <AnimaBaixo>
              <DashboardOneContract data={licenses} />
            </AnimaBaixo>
          </div>
        </div>
        {/* Conteudo da navbar de edição dos dados da licença */}

        <div className='tab-pane fade' id='kt_tab_pane_2' role='tabpanel'>
          {licenses.identifier ? <Vertical data={licenses} /> : <CardLoading />}
        </div>
        <div className='tab-pane fade' id='kt_tab_pane_3' role='tabpanel'>
          <AnimaCima2>
            <RelatedFilesWrapper data={licenses} />
          </AnimaCima2>
        </div>

        <div className='tab-pane fade' id='kt_tab_pane_4' role='tabpanel'>
          <AnimaCima2>
            <ContractPaymentListWrapper data={licenses} />
          </AnimaCima2>
        </div>
      </div>
    </>
  )
}

export {EditContracts}
